<script setup lang="ts">
import { CurrencyDollarIcon, RefreshIcon } from '@heroicons/vue/outline';

defineProps<{
    isLoading: boolean;
}>();

const emit = defineEmits<{
    refresh: [];
}>();
</script>

<template>
    <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div class="flex items-center gap-3">
            <div class="rounded-xl bg-[#242B59] p-2 text-[#48DDC3]">
                <CurrencyDollarIcon class="h-6 w-6" />
            </div>
            <div>
                <h1 class="text-2xl font-bold text-[#242B59]">
                    {{ $t('aura.processingCosts.title') }}
                </h1>
                <p class="mt-1 text-sm text-[#626468]">
                    {{ $t('aura.processingCosts.description') }}
                </p>
            </div>
        </div>
        <button
            class="flex w-full items-center justify-center gap-2 rounded-lg border border-[#E5E7EB] bg-white px-3 py-2 text-sm font-medium text-[#242B59] shadow-sm hover:bg-[#F8FAFC] sm:w-auto"
            :disabled="isLoading"
            @click="emit('refresh')"
        >
            <RefreshIcon class="h-4 w-4" :class="isLoading ? 'animate-spin' : ''" />
            {{ $t('aura.processingCosts.refresh') }}
        </button>
    </div>
</template>
